/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 16,
    height: 16,
    viewBox: '0 0 95 95',
    data: '<path pid="0" d="M47.5 20.9C16.337 20.9 0 43.86 0 47.5c0 3.641 16.337 26.6 47.5 26.6C78.661 74.1 95 51.141 95 47.5c0-3.64-16.339-26.6-47.5-26.6zm0 47.062c-11.659 0-21.112-9.161-21.112-20.462S35.841 27.038 47.5 27.038 68.611 36.199 68.611 47.5 59.159 67.962 47.5 67.962zM58.055 47.5c0 5.65-4.727 10.232-10.555 10.232-5.83 0-10.555-4.582-10.555-10.232S41.67 37.269 47.5 37.269c3.15 0-1.933 8.108 0 10.231 1.643 1.803 10.555-2.595 10.555 0z" _fill="#030104"/>'
  }
})
